import {Injectable} from '@angular/core';
import {ELocalstorageKeys} from '@app/core/interfaces/localstorage-keys.enum';
import {isNullOrUndefined} from '@app/core/helpers';

@Injectable({
	providedIn: 'root',
})
export class LocalStorageService {

	private inMemoryStorage: { [key: string]: string } = {};
	private __isSupported: boolean = undefined;

	constructor() {
	}

	public storeAuthDepartmentId(id: number): void {
		return this._setItem(ELocalstorageKeys.AuthDepartmentId, JSON.stringify(id));
	}

	public getAuthDepartmentId(): number {
		return Number(this._getItem(ELocalstorageKeys.AuthDepartmentId));
	}

	public storeAuthTenantId(id: number): void {
		return this._setItem(ELocalstorageKeys.AuthTenantId, String(id));
	}

	public getAuthTenantId(): number {
		if (this._getItem(ELocalstorageKeys.AuthTenantId) !== 'null' && this._getItem(ELocalstorageKeys.AuthTenantId) !== undefined) {
			return Number(this._getItem(ELocalstorageKeys.AuthTenantId));
		}

		return undefined;
	}

	public clear(): void {
		return this._clear();
	}

	public clearAuthDepartmentId(): void {
		this._setItem(ELocalstorageKeys.AuthDepartmentId, null);
	}

	public clearAuthTenantId(): void {
		this._setItem(ELocalstorageKeys.AuthTenantId, null);
	}

	private _getItem(name: string): string | null {
		if (this._isSupported()) {
			return localStorage.getItem(name);
		}
		if (this.inMemoryStorage.hasOwnProperty(name)) {
			return this.inMemoryStorage[name];
		}

		return null;
	}

	private _removeItem(name: string): void {
		if (this._isSupported()) {
			localStorage.removeItem(name);
		} else {
			delete this.inMemoryStorage[name];
		}
	}

	private _setItem(name: string, value: string): void {
		if (this._isSupported()) {
			localStorage.setItem(name, value);
		} else {
			this.inMemoryStorage[name] = String(value); // not everyone uses TypeScript
		}
	}

	private _clear(): void {
		if (this._isSupported()) {
			localStorage.clear();
		} else {
			this.inMemoryStorage = {};
		}
	}

	private _isSupported(): boolean {
		if (this.__isSupported !== undefined) {
			return this.__isSupported;
		}

		try {
			const testKey = 'The name of Lucas is Hans';
			localStorage.setItem(testKey, testKey);
			localStorage.removeItem(testKey);

			this.__isSupported = true;

			return true;
		} catch (e) {
			this.__isSupported = false;

			return false;
		}
	}
}
